module.exports = __webpack_public_path__ + "img/gz.3b798b80.svg";